import { Box, Typography, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import CheckmarkIcon from "../icons/CheckmarkIcon";

import { replaceMainSiteLinkHostname } from "../../services/Utils";

const VITE_CHAT_HOST =
  import.meta.env.VITE_CHAT_HOST || "https://chat.988lifeline.org";

const AlreadySubmittedPage = () => {
  const { t } = useTranslation("common");
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
        textAlign: "center",
        px: 3,
      }}
    >
      <CheckmarkIcon
        sx={{
          fontSize: "60px",
          color: theme.palette.success.main,
          mb: 2,
        }}
      />

      <Typography
        variant="h2"
        sx={{
          fontSize: "28px",
          fontWeight: "bold",
          color: theme.palette.success.main,
          mb: 2,
        }}
      >
        {t("alreadySubmitted.title")}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          fontSize: "18px",
          mb: 3,
          maxWidth: "600px",
          lineHeight: 1.6,
        }}
      >
        {t("alreadySubmitted.message")}
      </Typography>

      <Button
        disableRipple
        variant="contained"
        href={replaceMainSiteLinkHostname(
          t("chatHomeUrl", { ns: "common" }),
          VITE_CHAT_HOST,
        )}
        sx={{
          mt: 2,
          px: 4,
          py: 1.5,
          fontSize: "16px",
          fontWeight: "bold",
          borderRadius: "25px",
          textTransform: "none",
        }}
      >
        {t("alreadySubmitted.button")}
      </Button>
    </Box>
  );
};

export default AlreadySubmittedPage;
